(function () {
  if (window.__emptyCartAddReadyV2) return;
  window.__emptyCartAddReadyV2 = true;

  let isAdding = false;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-empty-cart-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (isAdding) return;

    const variantId = button.getAttribute('data-variant-id');
    const quantity = Number(button.getAttribute('data-quantity') || 1);

    if (!variantId) {
      console.error('[empty-cart-add] Variant ID vazio.');
      return;
    }

    isAdding = true;
    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity
        })
      });

      const addData = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(addData.description || 'Erro ao adicionar.');
      }

      const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sections = await sectionsResponse.json();

      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerContainer = document.querySelector('#CartDrawer');
      const cartIconBubble = document.querySelector('#cart-icon-bubble');

      if (sections['cart-drawer'] && cartDrawerContainer) {
        const parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newCartDrawerContent = parsedDrawer.querySelector('#CartDrawer');

        if (newCartDrawerContent) {
          cartDrawerContainer.innerHTML = newCartDrawerContent.innerHTML;
        }
      }

      if (sections['cart-icon-bubble'] && cartIconBubble) {
        const parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = parsedBubble.querySelector('#cart-icon-bubble');

        if (newBubble) {
          cartIconBubble.innerHTML = newBubble.innerHTML;
        }
      }

      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');

        const inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) {
          inner.classList.remove('is-empty');
          inner.scrollTop = 0;
        }

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open(button);
        } else {
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      }

    } catch (error) {
      console.error('[empty-cart-add]', error);
      alert('Não foi possível adicionar o produto ao carrinho.');
    } finally {
      isAdding = false;
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }, true);
})();